import React, { Component } from 'react';
import './task.css';
import { Draggable } from 'react-beautiful-dnd';
import Moment from 'react-moment';
import Avatar from 'react-avatar';
import { IoMdRemove } from 'react-icons/io';

export default class Task extends Component {
  getFirstTwocharOfWords = sentence => {
    var splitStr = sentence.toUpperCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase();
    }
    return splitStr.join(' ').substring(0, 5);
  };

  render() {
    return (
      <Draggable draggableId={this.props.task.id} index={this.props.index}>
        {provided => (
          <div
            className="task-container"
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}>
            <div className="task-content">
              <Avatar
                name={this.getFirstTwocharOfWords(this.props.task.content)}
                round
                size="40px"
                className="image-avatar"
              />
              <span className="content">{this.props.task.content} </span>
            </div>
            <div className="item-task">
              <span className="due-date">
                <Moment fromNow>{this.props.task.dueTime}</Moment>
              </span>
              <span className="task-delete">
                <IoMdRemove
                  size="1.5em"
                  onClick={() => {
                    this.props.deleteExistingTask(
                      this.props.boardID,
                      this.props.colID,
                      this.props.task.id
                    );
                    this.props.updateItemToRender();
                  }}
                />
              </span>
            </div>
          </div>
        )}
      </Draggable>
    );
  }
}
